import { PAGES } from './case-management-pages';
import { CssRoles } from '../css-roles';

const CanEditDataRoles = CssRoles.CaseValues.filter(
  (r) =>
    r.code !== CssRoles.CSSObserver.code &&
    r.code !== CssRoles.CSSInvestigator.code &&
    r.code !== CssRoles.AccountingOfficer.code &&
    r.code !== CssRoles.ContractProcurementSpecialist.code &&
    r.code !== CssRoles.ISDataEntry.code
);

// filter out any roles that can not view/open case file (like Information Services Data Entry)
const CanViewCaseFileDataRoles = CssRoles.CaseValues.filter((r) => r.code !== CssRoles.ISDataEntry.code);

const CaseManagementPagePermissions = {};
CaseManagementPagePermissions[PAGES.Audit.id] = {
  edit: [CssRoles.CECSupervisor, CssRoles.SFSCSupervisor],
  view: [],
};
CaseManagementPagePermissions[PAGES.PersonalInformation.id] = {
  edit: [
    CssRoles.CEC,
    CssRoles.DRES,
    CssRoles.SFSC,
    CssRoles.AdminAssistant,
    CssRoles.ARCAdvisor,
    CssRoles.ISCC,
    CssRoles.ChildSupportWorker,
    CssRoles.HealthFuneralBenefitsWorker,
    CssRoles.ExternalServiceProvider,
    CssRoles.PDDWorker,
    CssRoles.PrimeContractor,
  ],
  view: [
    CssRoles.ASCC,
    CssRoles.ARCAdvisor,
    CssRoles.ISDE,
    CssRoles.CSSObserver,
    CssRoles.CSSInvestigator,
    CssRoles.AccountingOfficer,
    CssRoles.ExternalServiceProvider,
    CssRoles.ContractProcurementSpecialist,
    CssRoles.PDDWorker,
    CssRoles.PrimeContractor,
  ],
  clientType: [CssRoles.CEC, CssRoles.SFSC],
  // Personal Details includes: Financail administrator, living condition, Is a sponsored immigrant,Indian registration number, Interpreter services required
  editPersonalDetails: [
    CssRoles.CEC,
    CssRoles.DRES,
    CssRoles.SFSC,
    CssRoles.AdminAssistant,
    CssRoles.ARCAdvisor,
    CssRoles.ISCC,
    CssRoles.ChildSupportWorker,
    CssRoles.HealthFuneralBenefitsWorker,
    CssRoles.PDDWorker,
  ],
  editSpouseDependent: [
    CssRoles.CEC,
    CssRoles.DRES,
    CssRoles.SFSC,
    CssRoles.AdminAssistant,
    CssRoles.ARCAdvisor,
    CssRoles.ISCC,
    CssRoles.ChildSupportWorker,
    CssRoles.HealthFuneralBenefitsWorker,
    CssRoles.PDDWorker,
  ],
};

CaseManagementPagePermissions[PAGES.Client.id] = {
  view: [...CanViewCaseFileDataRoles, CssRoles.PDDWorker],
};
CaseManagementPagePermissions[PAGES.Education.id] = {
  edit: [
    CssRoles.CEC,
    CssRoles.DRES,
    CssRoles.SFSC,
    CssRoles.AdminAssistant,
    CssRoles.ExternalServiceProvider,
    CssRoles.PDDWorker,
    CssRoles.PrimeContractor,
  ],
  view: [
    CssRoles.ChildSupportWorker,
    CssRoles.CSSObserver,
    CssRoles.CSSInvestigator,
    CssRoles.HealthFuneralBenefitsWorker,
    CssRoles.ExternalServiceProvider,
    CssRoles.ContractProcurementSpecialist,
    CssRoles.PDDWorker,
    CssRoles.PrimeContractor,
  ],
};
CaseManagementPagePermissions[PAGES.Employment.id] = {
  edit: [
    CssRoles.CEC,
    CssRoles.DRES,
    CssRoles.SFSC,
    CssRoles.AdminAssistant,
    CssRoles.ISCC,
    CssRoles.ExternalServiceProvider,
    CssRoles.PDDWorker,
    CssRoles.PrimeContractor,
  ],
  view: [
    CssRoles.ARCAdvisor,
    CssRoles.ChildSupportWorker,
    CssRoles.CSSObserver,
    CssRoles.CSSInvestigator,
    CssRoles.HealthFuneralBenefitsWorker,
    CssRoles.ExternalServiceProvider,
    CssRoles.ContractProcurementSpecialist,
    CssRoles.PrimeContractor,
  ],
};
CaseManagementPagePermissions[PAGES.IncomesAndAssets.id] = {
  edit: [CssRoles.CEC, CssRoles.DRES, CssRoles.SFSC, CssRoles.ISCC, CssRoles.ChildSupportWorker],
  view: [
    CssRoles.ARCAdvisor,
    CssRoles.AdminAssistant,
    CssRoles.CSSObserver,
    CssRoles.CSSInvestigator,
    CssRoles.HealthFuneralBenefitsWorker,
    CssRoles.PrimeContractor,
  ],
};
CaseManagementPagePermissions[PAGES.Incomes.id] = {
  edit: [],
  view: [CssRoles.ExternalServiceProvider],
};
CaseManagementPagePermissions[PAGES.Comments.id] = {
  edit: [
    CssRoles.CEC,
    CssRoles.DRES,
    CssRoles.SFSC,
    CssRoles.ASCC,
    CssRoles.ARCAdvisor,
    CssRoles.AdminAssistant,
    CssRoles.ISCC,
    CssRoles.ISDE,
    CssRoles.ChildSupportWorker,
    CssRoles.HealthFuneralBenefitsWorker,
    CssRoles.CSSInvestigator,
    CssRoles.AccountingOfficer,
    CssRoles.ExternalServiceProvider,
    CssRoles.ContractProcurementSpecialist,
    CssRoles.PDDWorker,
    CssRoles.PrimeContractor,
  ],
  view: [
    CssRoles.CSSObserver,
    CssRoles.ExternalServiceProvider,
    CssRoles.ContractProcurementSpecialist,
    CssRoles.PDDWorker,
    CssRoles.PrimeContractor,
  ],
};
CaseManagementPagePermissions[PAGES.Reminders.id] = {
  edit: [
    CssRoles.CEC,
    CssRoles.DRES,
    CssRoles.SFSC,
    CssRoles.ISCC,
    CssRoles.ISDE,
    CssRoles.ChildSupportWorker,
    CssRoles.AdminAssistant,
    CssRoles.ExternalServiceProvider,
    CssRoles.InvestigationsAdmin,
    CssRoles.PDDWorker,
    CssRoles.PrimeContractor,
  ],
  view: [
    CssRoles.ASCC,
    CssRoles.ARCAdvisor,
    CssRoles.CSSObserver,
    CssRoles.HealthFuneralBenefitsWorker,
    CssRoles.PrimeContractor,
  ],
};
CaseManagementPagePermissions[PAGES.IntakeAssessment.id] = {
  edit: [CssRoles.CEC, CssRoles.DRES, CssRoles.ExternalServiceProvider, CssRoles.PrimeContractor],
  view: [
    CssRoles.SFSC,
    CssRoles.ASCC,
    CssRoles.ARCAdvisor,
    CssRoles.AdminAssistant,
    CssRoles.ISCC,
    CssRoles.ISDE,
    CssRoles.ChildSupportWorker,
    CssRoles.CSSObserver,
    CssRoles.CSSInvestigator,
    CssRoles.HealthFuneralBenefitsWorker,
    CssRoles.ExternalServiceProvider,
    CssRoles.ContractProcurementSpecialist,
    CssRoles.PrimeContractor,
  ],
  fullAssessment: [
    CssRoles.CEC,
    CssRoles.DRES,
    CssRoles.SFSC,
    CssRoles.ARCAdvisor,
    CssRoles.AdminAssistant,
    CssRoles.ISCC,
    CssRoles.ISDE,
    CssRoles.ChildSupportWorker,
    CssRoles.CSSObserver,
    CssRoles.CSSInvestigator,
    CssRoles.HealthFuneralBenefitsWorker,
    CssRoles.ExternalServiceProvider,
    CssRoles.ContractProcurementSpecialist,
    CssRoles.PrimeContractor,
  ],
  deed: [CssRoles.DEEDAnalysisViewer],
  startIntake: [CssRoles.CEC, CssRoles.ASCC],
  move: [CssRoles.CSSAdmin, CssRoles.CompassAdmin],
  delete: [CssRoles.CSSAdmin, CssRoles.CompassAdmin],
};
CaseManagementPagePermissions[PAGES.DERA.id] = {
  edit: [CssRoles.ExternalServiceProvider, CssRoles.PrimeContractor],
  view: [
    CssRoles.CEC,
    CssRoles.DRES,
    CssRoles.SFSC,
    CssRoles.ASCC,
    CssRoles.ARCAdvisor,
    CssRoles.AdminAssistant,
    CssRoles.ISCC,
    CssRoles.ISDE,
    CssRoles.ChildSupportWorker,
    CssRoles.CSSObserver,
    CssRoles.CSSInvestigator,
    CssRoles.HealthFuneralBenefitsWorker,
    CssRoles.ExternalServiceProvider,
    CssRoles.ContractProcurementSpecialist,
  ],
};
CaseManagementPagePermissions[PAGES.ActionPlan.id] = {
  edit: [CssRoles.CEC, CssRoles.DRES, CssRoles.SFSC, CssRoles.ExternalServiceProvider, CssRoles.PrimeContractor],
  create: [CssRoles.CEC, CssRoles.DRES, CssRoles.SFSC, CssRoles.ExternalServiceProvider, CssRoles.PrimeContractor],
  delete: [CssRoles.CECSupervisor, CssRoles.SFSCSupervisor],
  view: [
    CssRoles.ASCC,
    CssRoles.AdminAssistant,
    CssRoles.ISCC,
    CssRoles.ISDE,
    CssRoles.ChildSupportWorker,
    CssRoles.CSSObserver,
    CssRoles.CSSInvestigator,
    CssRoles.HealthFuneralBenefitsWorker,
    CssRoles.ExternalServiceProvider,
    CssRoles.ContractProcurementSpecialist,
    CssRoles.ARCAdvisor,
    CssRoles.PrimeContractor,
  ],
  canAssign: [
    CssRoles.CEC,
    CssRoles.DRES,
    CssRoles.SFSC,
    CssRoles.AdminAssistant,
    CssRoles.ExternalServiceProvider,
    CssRoles.PrimeContractor,
  ],
  canRefer: [CssRoles.CEC, CssRoles.DRES, CssRoles.PrimeContractor],
};
CaseManagementPagePermissions[PAGES.Settings.id] = {
  edit: [...CssRoles.CaseValues],
  view: [],
};
CaseManagementPagePermissions[PAGES.AdminSettings.id] = {
  edit: [CssRoles.CSSAdmin],
  view: [CssRoles.CompassAdmin],
  limited: [CssRoles.CompassAdmin],
  amount: [CssRoles.CompassAdmin],
  bulkComment: [CssRoles.CompassAdmin],
};

CaseManagementPagePermissions[PAGES.WorkerDashboard.id] = {
  edit: [...CssRoles.CaseValues],
  view: [],
  //I think these actually make more sense as user settings, which default based on role.  But for now they are fine here

  //**main tab */
  hasCalendar: [
    CssRoles.CEC,
    CssRoles.DRES,
    CssRoles.SFSC,
    CssRoles.ExternalServiceProvider,
    CssRoles.PDDWorker,
    CssRoles.PrimeContractor,
  ],
  hasAssignment: [
    CssRoles.CEC,
    CssRoles.DRES,
    CssRoles.SFSC,
    CssRoles.AdminAssistant,
    CssRoles.ExternalServiceProvider,
    CssRoles.PDDWorker,
    CssRoles.PrimeContractor,
  ],

  hasSearch: [...CanViewCaseFileDataRoles],
  hasInformationServices: [
    ...CssRoles.CaseValues.filter(
      (r) =>
        r.code !== CssRoles.PDDWorker.code &&
        r.code !== CssRoles.PDDAdmin.code &&
        r.code !== CssRoles.PrimeContractor.code
    ),
  ],
  hasTeam: [CssRoles.CECSupervisor, CssRoles.SFSCSupervisor],
  hasOngoingAlerts: [CssRoles.DEEDAnalysisViewer],
  hasOngoingAssignments: [CssRoles.DEEDAnalysisViewer],
  //**main tab */

  //** worker-dashboard */
  hasEraList: [
    CssRoles.CEC,
    CssRoles.DRES,
    CssRoles.SFSC,
    CssRoles.AdminAssistant,
    CssRoles.ExternalServiceProvider,
    CssRoles.PrimeContractor,
  ],
  hasReferralsList: [CssRoles.ExternalServiceProvider],
  hasIntakeList: [CssRoles.CEC],
  hasADAPIntakeList: [CssRoles.PrimeContractor],
  hasStreamCIntakeList: [CssRoles.PrimeContractor],

  // case management tab//
  hasActionPlanList: [
    CssRoles.CEC,
    CssRoles.DRES,
    CssRoles.SFSC,
    CssRoles.AdminAssistant,
    CssRoles.ExternalServiceProvider,
    CssRoles.PrimeContractor,
  ],

  //pdd tab//
  hasPDDList: [CssRoles.PDDWorker, CssRoles.PDDAdmin],
  //** worker-dashboard */

  bulkReassignCases: [CssRoles.CECSupervisor, CssRoles.SFSCSupervisor, CssRoles.ExternalServiceProvider],
  canCreateClient: [
    CssRoles.CEC,
    CssRoles.DRES,
    CssRoles.AdminAssistant,
    CssRoles.ASCC,
    CssRoles.ISCC,
    CssRoles.HealthFuneralBenefitsWorker,
    CssRoles.ExternalServiceProvider,
    CssRoles.PDDWorker,
  ],
};

CaseManagementPagePermissions[PAGES.AuthManagement.id] = {
  edit: [CssRoles.AuthManager, CssRoles.CSSAdmin, CssRoles.ContractProcurementSpecialist, CssRoles.PDDAdmin],
  view: [],
};

CaseManagementPagePermissions[PAGES.InformationServices.id] = {
  hasWorkshops: [CssRoles.ExternalServiceProvider, CssRoles.ISDataEntry, CssRoles.ContractProcurementSpecialist],
};

CaseManagementPagePermissions[PAGES.CommentTemplates.id] = {
  edit: [CssRoles.CSSManager, CssRoles.CSSAdmin],
};

CaseManagementPagePermissions[PAGES.FileHistory.id] = {
  view: [...CssRoles.CaseValues],
};

CaseManagementPagePermissions[PAGES.FileRestrictionManagement.id] = {
  edit: [CssRoles.CSSManager, CssRoles.ContractProcurementSpecialist],
};

CaseManagementPagePermissions['Reports'] = {
  view: [CssRoles.CEC, CssRoles.DRES, CssRoles.SFSC],
  individualReport: [CssRoles.CEC, CssRoles.DRES, CssRoles.SFSC],
  regionReport: [CssRoles.CSSManager],
  auditReport: [CssRoles.CSSManager, CssRoles.CECSupervisor, CssRoles.SFSCSupervisor],
};
CaseManagementPagePermissions[PAGES.LMTAActivities.id] = {
  edit: [CssRoles.PDDWorker, CssRoles.PDDAdmin],
};
CaseManagementPagePermissions[PAGES.LabourMarket.id] = {
  edit: [CssRoles.PDDWorker, CssRoles.PDDAdmin],
};

CaseManagementPagePermissions[PAGES.OngoingEligibility.id] = {
  view: [CssRoles.DEEDAnalysisViewer],
  //used by masterlist component on the worker dashboard page
  accessAllRegions: [CssRoles.CECSupervisor, CssRoles.SFSCSupervisor],
  canSelfAssign: [CssRoles.CEC, CssRoles.SFSC, CssRoles.CECSupervisor, CssRoles.SFSCSupervisor],
  canUnassignOthers: [CssRoles.CECSupervisor, CssRoles.SFSCSupervisor],
};

const CaseManagementDataPermissions = {
  edit: [...CanEditDataRoles],
  homePage: [...CssRoles.CaseValues],
  view: [...CanViewCaseFileDataRoles],
  ISDataEntry: [CssRoles.ISDataEntry, CssRoles.ContractProcurementSpecialist],
  Comments: [...CssRoles.CaseValues],
  IntakeAssessment: [CssRoles.CEC, CssRoles.DRES, CssRoles.ExternalServiceProvider, CssRoles.PrimeContractor],
  DERA: [CssRoles.ExternalServiceProvider, CssRoles.PrimeContractor],
  FileRestrictions: [CssRoles.CSSManager, CssRoles.ContractProcurementSpecialist],
  move: [CssRoles.CSSAdmin, CssRoles.CompassAdmin],
  delete: [CssRoles.CSSAdmin, CssRoles.CompassAdmin],
  changeHsId: [CssRoles.CSSAdmin, CssRoles.CompassAdmin],
  mergeFiles: [CssRoles.CSSAdmin, CssRoles.CompassAdmin],
  bulkComments: [CssRoles.CSSAdmin, CssRoles.CompassAdmin],
  // ActionPlan: {
  // do we need to go finer grained then edit/view on general data?
  // }
};

export { CaseManagementPagePermissions, CaseManagementDataPermissions };
